<span>
    <span>{{item.code}}</span>
    <span *ngIf="item.libelle && item.libelle != item.code"> - {{item.libelle}}</span>
</span>